
import Vue, { PropType } from 'vue';
import InfoBox from '../components/InfoBox.vue';
import Select, { SelectOption } from '~/components/builders/Base/Select.vue';
import { CandidateJobBuilder, JobSkill } from '~/utils/candidate';
import { PredefinedSkill } from '~/services/CandidateService';

export default Vue.extend({
    name: 'SkillsForm',
    components: {
        InfoBox,
        Select,
    },
    props: {
        builder: {
            type: Object as PropType<CandidateJobBuilder>,
            required: true,
        },
        allSkills: {
            type: Array as PropType<PredefinedSkill[]>,
            required: true,
        },
    },
    data() {
        return {
            selectedSkill: '',
            skills: this.builder.getSkills(),
        };
    },
    mounted() {
        this.$watch('skills', this.builder.watchSkills());
    },
    computed: {
        skillOptions(): SelectOption[] {
            return this.allSkills.reduce<SelectOption[]>((acc, skill) => {
                if (!this.skills.some(s => s.skillId === skill.id))
                    acc.push({
                        value: skill.id,
                        label: skill.name,
                    });
                return acc;
            }, []);
        },
        renderedSkills(): (SelectOption & { isNew: boolean })[] {
            const getLabel = (skill: JobSkill) => {
                const predefinedSkill = this.allSkills.find(s => s.id === skill.skillId);
                if (predefinedSkill) return predefinedSkill.name;
                return skill.customSkillName || 'Unknown';
            };

            return this.skills
                .map(skill => ({
                    value: skill.id,
                    label: getLabel(skill),
                    isNew: CandidateJobBuilder.isTempItem(skill),
                }))
                .sort((a, b) => a.label.localeCompare(b.label));
        },
    },
    methods: {
        handleAddSkill(skill: string, custom: boolean) {
            let skillId = custom ? null : skill;
            let customSkillName = custom ? skill : null;
            if (custom) {
                const name = skill.toLocaleLowerCase();
                const found = this.allSkills.find(s => s.name.toLocaleLowerCase() === name);
                if (!!found) {
                    skillId = found.id;
                    customSkillName = null;
                }
            }

            this.skills.push({
                id: CandidateJobBuilder.generateId(),
                skillId,
                customSkillName,
            });
        },
        handleRemoveSkill(id: string) {
            const skills = [...this.skills].filter(skill => skill.id !== id);
            this.skills = skills;
        },
    },
});
